export default {
  sections: {
    business_info: 'Bedrijfsgegevens',
    bank_info: 'Bankgegevens',
  },
  form: {
    company_name: {
      label: 'Restaurantnaam',
      placeholder: 'Restaurantnaam',
    },
    business_name: {
      label: 'Bedrijfsnaam',
      placeholder: 'Bedrijfsnaam',
    },
    owner_full_name: {
      label: 'Naam eigenaar',
      placeholder: 'Naam eigenaar',
    },
    business_address: {
      label: 'Bedrijfsadres',
      placeholder: 'Bedrijfsadres',
    },
    business_zip_code: {
      label: 'Postcode bedrijf',
      placeholder: 'Postcode bedrijf',
    },
    business_city: {
      label: 'Bedrijfsplaats',
      placeholder: 'Bedrijfsplaats',
    },
    business_country: {
      label: 'Land bedrijf',
      options: {
        DE: 'Duitsland',
        GB: 'Verenigd Koninkrijk',
        US: 'Verenigde Staten',
      },
    },
    company_phone_number: {
      label: 'Telefoonnummer restaurant',
      placeholder: 'Telefoonnummer restaurant',
    },
    contact_person_full_name: {
      label: 'Naam contactpersoon',
      placeholder: 'Naam contactpersoon',
    },
    contact_person_phone_number: {
      label: 'Telefoonnummer contactpersoon',
      placeholder: 'Telefoonnummer contactpersoon',
    },
    contact_person_email: {
      label: 'E-mail contactpersoon',
      placeholder: 'E-mail contactpersoon',
    },
    business_bank_account_holder_name: {
      label: 'Naam rekeninghouder',
      placeholder: 'Naam rekeninghouder',
    },
    business_bank_account_number: {
      label: 'Bankrekeningnummer',
      placeholder: 'DE01101234567891234567',
    },
    business_bank_routing_number: {
      label: 'Bankroutingnummer',
      placeholder: '110000000',
    },
    business_tax_id: {
      label: 'Fiscaal ID bedrijf',
      placeholder: 'Fiscaal ID bedrijf',
    },
  },
};
